import { CustomStatusPanelProps } from "ag-grid-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import ssrmSelection from "~/helpers/grid/ssrmSelection";
import formatLocaleNumber from "~/helpers/localeNumberFormat";

const readSelectedCount = (api: CustomStatusPanelProps["api"]): number => {
	const liveCount = api.getSelectedRows().length;
	if (api.getGridOption("rowModelType") !== "serverSide") return liveCount;
	const state = api.getServerSideSelectionState();
	const flatState = ssrmSelection.isFlatSelectionState(state) ? state : null;
	return ssrmSelection.computeSelectedCount(flatState, api.getDisplayedRowCount(), liveCount);
};

const GridSelectedRowCountStatusPanel = (props: CustomStatusPanelProps) => {
	const { t } = useTranslation("common");
	const [selectedCount, setSelectedCount] = useState(0);

	useEffect(() => {
		const update = () => {
			if (props.api.isDestroyed()) return;
			setSelectedCount(readSelectedCount(props.api));
		};
		update();
		props.api.addEventListener("selectionChanged", update);
		props.api.addEventListener("modelUpdated", update);

		return () => {
			if (props.api.isDestroyed()) return;
			props.api.removeEventListener("selectionChanged", update);
			props.api.removeEventListener("modelUpdated", update);
		};
	}, [props.api]);

	// ag-grid-react never attaches a stateless panel whose portal has no DOM child, so this must not return null.
	if (selectedCount === 0) return <div />;

	return (
		<div style={{ padding: "5px" }}>
			<span>{t("grid.selectedCount", { count: selectedCount, qty: formatLocaleNumber(selectedCount) })}</span>
		</div>
	);
};

export default GridSelectedRowCountStatusPanel;
